// src/features/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { settingService } from '../services/api/setting.service';
import { walletService } from '../services/api/wallet.service';
import { authService } from '../services/auth.service';
import { onboardingAPI } from '../services/api/onboarding.service';
export const getCurrentPhase = createAsyncThunk('data/fetchCurrentPhase', async (token:string) => {
  try{
   const phaseData = await authService.checkCurrentPhase(token);   
    return phaseData;
  }  catch(error) {

  }   
});
export const getTicketStatus = createAsyncThunk('data/fetchTicketStatus', async () => {
  try{
    const phaseData = await authService.checkTicketStatus();   
    return phaseData;
  }  catch(error) {

  }   
});
export const getOnboardingStatus = createAsyncThunk('data/fetchOnboardingStatus', async (referralCode:string) => {
  try{
    const phaseData = await onboardingAPI.startChat(referralCode);   
    return phaseData;
  }  catch(error) {

  }   
});

// export const getFiatPrices = createAsyncThunk('data/fetchFiatPrices', async () => {
//   const response = await settingService.getFiatCurrency();
//   return response;
// });
// export const getCryptoWallets = createAsyncThunk('data/fetchCryptoWallets', async () => {
//   const response = await walletService.getCryptoWallets();        
//   return response;
// });
// export const getMasterCardData = createAsyncThunk('data/fetchMasterCardData', async () => {
//   const response = await cardService.getMasterCardData();    
//   return response;
// });
// export const createCryptoWallet = createAsyncThunk('data/createCryptoWallet', async (currency:string) => {
//   const response = await walletService.createWallet(currency);   
//   return response;
// });
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: {
        data:{
          accountStatus: "",
          accountType: "",
          email: "",
          id: "",
          isEmailVerified: true,
          isTwoFactorEnabled: false,
          profile: {
            addressLine1: null,
            addressLine2: null,
            alternativePhone: null,
            birthCountry: null,
            birthDate: null,
            birthPlace: null,
            citizenship: null,
            city: null,
            country: null,
            createdAt: "2025-09-02T21:20:09.967Z",
            curpRfc: null,
            currentResidence: null,
            documentCountry: null,
            documentExpiry: null,
            documentNumber: null,
            documentType: null,
            email: "softwared953@gmail.com",
            employerName: null,
            employmentStatus: null,
            euResidencyStatus: null,
            firstName: "test",
            fullName: "test test",
            gender: null,
            id: "cmf31y0a703x812q9c6sz1qkp",
            incomeSource: null,
            isPep: null,
            jobTitle: null,
            lastIpAddress: null,
            lastName: "test",
            middleName: null,
            monthlyIncome: null,
            monthlyIncomeRange: null,
            nationalities: [],
            occupation: null,
            occupationCode: null,
            occupationName: null,
            passports: null,
            phone: null,
            phoneCountryCode: null,
            phoneNumber: null,
            photoProfileUpdatedAt: null,
            photoProfileUrl: null,
            postalCode: null,
            primaryNationality: null,
            registrationIp: null,
            secondCitizenship: null,
            secondLastName: null,
            state: null,
            taxCountry: null,
            taxNumber: null,
            taxResidence: null,
            tier: "BASIC",
            updatedAt: "2025-09-02T21:49:20.949Z",
            usResidencyStatus: null,
            userId: "cmf31xmvq03x212q9vuso92cb"
          },
          referralInfo: null,
          role: "CLIENT"
        },
        onboardingComplete:false,
        status:"idle"
    }, 
    ticketStatus:{
        data:{
          hasAccount: false,
          accountStatus: "NOT_REQUESTED",         
          message: "Su solicitud está pendiente de revisión",
          ticketId: "cmexjnbni000wnr606nqctog4",
          ticketStatus: "PENDING",
        },
        status:"idle",
    }

  },
  reducers: {
    updateTicketStatus(state, data){
      console.log(data);
        state.ticketStatus.data.ticketId = data.payload;
        // state.ticketStatus.data.isCompleted = data.payload.isCompleted;
        // state.ticketStatus.data.ticketStatus = data.payload.ticketStatus;
        // state.ticketStatus.status = "succeeded"
    },
    UpdateUser(state, data){
      state.user.data = data.payload;
      state.user.status = 'succeeded';
    },
    logoutAuth: (state) => {
      // state.ticketStatus.data.hasTicket = false;
      // state.ticketStatus.data.isCompleted = false;
      // state.ticketStatus.data.ticketStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // .addCase(getCurrentPhase.pending, (state) => {
      //   state.ticketStatus.status = 'loading';
      // })
      .addCase(getTicketStatus.fulfilled, (state, action) => {
        state.ticketStatus.status = 'succeeded';
        console.log(action.payload)
        if (action.payload && action.payload.data) {
          state.ticketStatus.data.accountStatus = action.payload.data.accountStatus;
          state.ticketStatus.data.hasAccount = action.payload.data.hasAccount;
        }
      })
      .addCase(getTicketStatus.rejected, (state, action) => {
        state.ticketStatus.status = 'failed';
      })
      .addCase(getOnboardingStatus.pending, (state) => {
        state.user.status = 'loading';
      })
      .addCase(getOnboardingStatus.fulfilled, (state, action) => {
        if (action.payload && action.payload.data) {
          state.user.onboardingComplete = action.payload.data.isComplete;
        }
        //  state.user.data.onboardingComplete = false;
         state.user.status = 'succeeded';
      })
      .addCase(getOnboardingStatus.rejected, (state, action) => {
        state.user.status = 'failed';
      })
      
    // .addCase(getFiatPrices.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(getFiatPrices.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    //   state.data.fiatPrices = action.payload;
    // })
    // .addCase(getFiatPrices.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error.message;
    // });
    //   .addCase(getMasterCardData.pending, (state) => {
    //     state.status = 'loading';
    //   })
    //   .addCase(getMasterCardData.fulfilled, (state, action) => {
    //     const newCards = Array.isArray(action.payload.data?.data)
    //       ? action.payload.data.data.filter(
    //           (newCard) => !state.data.masterCard.some((existing) => existing.id === newCard.id)
    //         )
    //       : [];
    //     console.log('Pushing MasterCard data:', newCards); // Debug log
    //     state.data.masterCard.push(...newCards);
    //   })
    //   .addCase(getMasterCardData.rejected, (state, action) => {
    //     state.status = 'failed';
    //     state.error = action.error.message;
    //   });
    // .addCase(createCryptoWallet.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(createCryptoWallet.fulfilled, (state, action) => {
    //   const newWallet = Array.isArray(action.payload.wallet)
    //     ? action.payload.wallet.filter(
    //         (newCard) => !state.data.masterCard.some((existing) => existing.id === newCard.id)
    //       )
    //     : [];       
    //   state.data.cryptoWallets.push(...newWallet);
    // })
    // .addCase(createCryptoWallet.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error.message;
    // });
  },
});

export const { updateTicketStatus, logoutAuth, UpdateUser } = authSlice.actions;
export default authSlice.reducer;